// extracted by mini-css-extract-plugin
module.exports = {"card":"ProductActionElements_card__7addf","buttonMargin":"ProductActionElements_buttonMargin__bfb72","buttons":"ProductActionElements_buttons__2d638"};